// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__wD0qm","main":"Layout_main__7SzOn"};